// src/utils/ProductReview.js
import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;
/**
 * Post a new product review.
 * @param {Object} payload - { productId, userId, comments, rating }
 * @returns {Promise<Object>} API response.
 */
export const postProductReview = async (payload) => {
  const response = await axios.post(
    `${baseUrl}/api/ColtecProduct/ProductReview`,
    payload
  );
  return response.data;
};
